export const FALLBACK_ERROR_MESSAGE =
  'Application error. Please try again after some time';

export const PLACEHOLDER_EXPORT = '';
